import React from "react";
import { PieChart as REPieChart, Pie, Cell } from "recharts";
import { useTheme } from "@material-ui/styles";

interface PieChartProps {
  width?: number;
  height?: number;
  data: { [ket: string]: string | Array<number> | Object }[];
}

const PieChart = ({ width = 100, height = 100, data }: PieChartProps) => {
  const theme: CustomTheme.RootObject = useTheme();
  const COLORS = [
    theme.palette.success.main,
    theme.palette.error.main,
    theme.palette.grey["500"],
    theme.palette.warning.main,
    theme.palette.info.main,
  ];

  return (
    <REPieChart width={width} height={height}>
      <Pie
        data={data}
        cx={width / 2}
        cy={height / 2}
        innerRadius={width / 3.5}
        outerRadius={width / 3}
        paddingAngle={5}
        isAnimationActive={false}
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
            strokeWidth={0}
          />
        ))}
      </Pie>
    </REPieChart>
  );
};

export default PieChart;
